import { render, staticRenderFns } from "./FormInstrutorCadastro.vue?vue&type=template&id=5d4c754c"
import script from "./FormInstrutorCadastro.vue?vue&type=script&lang=js"
export * from "./FormInstrutorCadastro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports